import classNames from 'classnames';

import { useAppDispatch } from 'app/hooks';
import { setLocale } from 'features/intl/intlSlice';

import { Hint } from 'components/hint/Hint';
import { getLanguageName } from 'helpers/intl/intlHelpers';
import { useCallback, useMemo } from 'react';
import './LocaleSelector.scss';

type LocaleSelectorProps = {
  locale: string;
  className?: string;
};

export default function LocaleSelector(props: LocaleSelectorProps) {
  const { locale, className } = props;
  const dispatch = useAppDispatch();
  const targetLocale = locale !== 'nl' ? 'nl' : 'en';
  const loc = useMemo(
    () => getLanguageName(targetLocale, targetLocale),
    [targetLocale],
  );

  const setLoc = useCallback(() => {
    dispatch(setLocale(targetLocale));
  }, [dispatch, targetLocale]);

  return (
    <Hint hint={loc} placement="bottom">
      <div className={classNames('localeselector', className)} onClick={setLoc}>
        {targetLocale.toUpperCase()}
      </div>
    </Hint>
  );
}
